import { Component, OnInit } from '@angular/core';
import { AlertComponent } from 'app/popup/alert.component';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { DialogService } from 'ng2-bootstrap-modal';
import { ActivatedRoute, Router } from '@angular/router';
import {DocumenttypeService} from 'app/services/documenttype.service';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { AuthWebService } from 'app/services/authweb.service';
import { ToastrService } from 'ngx-toastr';
import { ToastNotificationService } from 'app/shared/toast-notification/toast-notification.service';

@Component({
  selector: 'app-document-type',
  templateUrl: './document-type.component.html',
  styleUrls: ['./document-type.component.css']
})
export class DocumentTypeComponent implements OnInit {
  form;
  vDocType: any = {};
  sub: any;
  lblHeading = '';
  btnActionLabel = '';
  isEdit: boolean;  
  isDup = false;  
  selectedGroupCode: any = {};
  selectedDisplay = 3;
  message = null;
  now = new Date();
  audit = { created: '', updated: '' };
  user = { LastName: '' };
  
  public isLoading = false;

  constructor(private service: DocumenttypeService, private authWebService: AuthWebService,
    private router: Router,
    private route: ActivatedRoute,private toastService:ToastNotificationService,
     public utility: UtilityServiceService,private toastr: ToastrService) { }

  ngOnInit() {
    this.initForm();    
    this.onChanges();
    this.user.LastName = (this.authWebService.userData) ? this.authWebService.userData.User.LastName : '';
    this.sub = this.route.params.subscribe(params => {
      if (this.router.url.indexOf('edit') != -1) {
        this.isEdit = true;
        this.lblHeading = 'Edit Document Type';
        this.btnActionLabel = 'Update';
        const id = +params['id'];
        this.isLoading = true;
        //console.log(this.vDocType.multiple_allowed);
        this.service.getById(id).subscribe(result => {
          this.vDocType = result;
          this.isLoading = false;
          (<FormGroup>this.form)
            .setValue({
              id: this.vDocType.id
              , code: this.vDocType.code
              , description: this.vDocType.description
              , document_link: this.vDocType.document_link
              , group_code: this.vDocType.group_code
              , sort_order: this.vDocType.sort_order
              , is_active: this.vDocType.is_active
              , multiple_allowed:this.vDocType.multiple_allowed==1 ? 'true' :  false
              , is_for_vehicle:this.vDocType.is_for_vehicle==1 ? 'true' : false
              , is_template: this.vDocType.is_template
              , is_download: this.vDocType.is_download
              , display_ind: this.vDocType.display_ind
              , date_created: this.vDocType.date_created
              , date_modified: this.vDocType.date_modified
              , user_created: this.vDocType.user_created
              , user_modified: this.vDocType.user_modified
              
            }, { onlySelf: true });
          this.audit = this.utility.setAuditAttributes(this.vDocType.date_created, this.vDocType.user_created, this.vDocType.date_modified, this.vDocType.user_modified);
        });
      } else {
        this.isEdit = false;
        this.lblHeading = 'New Document Type';
        this.btnActionLabel = 'Save';
        this.audit = this.utility.setAuditAttributes(this.now, this.user.LastName, this.now, this.user.LastName); 
      }


    });
  }
  initForm() {
    this.form = new FormGroup({
      id: new FormControl()
      , code: new FormControl(this.vDocType.code, Validators.compose([Validators.required, <any>Validators.maxLength(12), Validators.pattern('[\\w\-\\s\\/]+')]))
      , description: new FormControl(this.vDocType.description, Validators.maxLength(100))
      , document_link: new FormControl(this.vDocType.description, Validators.maxLength(100))
      , group_code: new FormControl(this.vDocType.group_code, Validators.compose([Validators.required, <any>Validators.maxLength(12)]))
      , sort_order: new FormControl(this.vDocType.sort_code)
      , is_active: new FormControl()
      , multiple_allowed: new FormControl()
      , is_for_vehicle: new FormControl()
      , is_template: new FormControl()
      , is_download: new FormControl()
      , display_ind: new FormControl(this.vDocType.display_ind)
      , date_created: new FormControl()
      , date_modified: new FormControl()
      , user_created: new FormControl()
      , user_modified: new FormControl()
      
    });
    this.form.patchValue(this.utility.defaults);
  }

  onChanges(): void {
    this.form.get('code').valueChanges.subscribe(code => {

      if (code.length > 1) {
        this.service.checkByCode(code.trim()).subscribe((result:any) => {
          this.isDup = (result.Status && !this.isEdit) ? true : false;
        }, error => {
          this.isDup = false;

        });
      }
    });
  }

  navigate() {
    this.router.navigateByUrl('/document/type/list');
  }
  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  onSubmit(obj: any) {
    if (this.isDup) { return; }
    this.vDocType = obj;
    this.message = (this.isEdit) ? "Updating Document Type..." : "Adding a new Document Type...";
    if (this.isEdit) {
      this.vDocType.date_modified = new Date();
      this.vDocType.user_modified = this.user.LastName;
      this.isLoading = true;
      //console.log(JSON.stringify(obj));
      this.service.update(this.vDocType).subscribe(result => {
        this.vDocType = result;
        this.isLoading = false;
        // this.dialogService.addDialog(AlertComponent, { title: 'Update Document Type', message: `Document Type ${this.vDocType.code} updated succesfully.`, bold: `${this.vDocType.code}` });
        this.toastService.success(`Document Type ${this.vDocType.code} updated succesfully.`,'Update Document Type');

        this.navigate();
      });
    } else {
      this.vDocType.date_modified = this.vDocType.date_created = new Date();
      this.vDocType.user_modified = this.vDocType.user_created = this.user.LastName;

      this.isLoading = true;
      //console.log(JSON.stringify(this.vDocType));
      this.service.add(this.vDocType).subscribe(result => {
        this.vDocType = result;
        this.isLoading = false;
        // this.dialogService.addDialog(AlertComponent, { title: 'New Document Type', message: `New Document Type ${this.vDocType.code} added successfully.`, bold: `${this.vDocType.code}` });
        this.toastService.success(`New Document Type ${this.vDocType.code} added successfully.`,'New Document Type');

        this.navigate();
      });
    }
  }
  onSelectChange(){
    
  }

}
